import config_ext from '../../../config_ext.js'

export const auth0_config = {
  domain: config_ext.auth0.domain,
  client_id: config_ext.auth0.client_id,
  audience: config_ext.auth0.audience,
}